import { Col, TabContent, TabPane } from "reactstrap";
import { H3, H4, P } from "../../../AbstractElements";
import { Attechments, DearSirGoodMorning, DownloadAll, Elementumvarius, Hello, Href, Lorem, Lorem2 } from "../../../Constant";
import { EMAIL_LIST } from "../../../Data/Email";
import Attachment from "./Attachment";
import { EmailTabOrgProp } from "../../../Type/EmailType";
import { EmailTabHead } from "./EmailTabHead";

const EmailTabOrg = ({ orgactiveTab }: EmailTabOrgProp) => {
  return (
    <Col xl="8" md="12" className="box-md-8 pl-0">
      <TabContent activeTab={orgactiveTab}>
        {EMAIL_LIST.map((data, index) => (
          <TabPane tabId={index + 1} key={index}>
            <div className="email-right-aside">
              <div className="email-body radius-left">
                <div className="email-content">
                  <div className="email-top">
                    <EmailTabHead data={data} />
                  </div>
                  <div className="email-wrapper">
                    <P>{Hello}</P>
                    <P>{DearSirGoodMorning}</P>
                    <H3>{Elementumvarius}</H3>
                    <P className="m-b-20">{Lorem}</P>
                    <P>{Lorem2}</P>
                    <hr />
                    <div className="d-inline-block">
                      <H4 className="text-muted"><i className="icofont icofont-clip" /> {Attechments}</H4>
                      <a className="text-muted text-end right-download" href={Href}><i className="fa fa-long-arrow-down me-2" />{DownloadAll}</a>
                      <div className="clearfix" />
                    </div>
                    <Attachment />
                  </div>
                </div>
              </div>
            </div>
          </TabPane>
        ))}
      </TabContent>
    </Col>
  );
};
export default EmailTabOrg;
